/**
 * The host's banner in the web room when someone asks to join or rejoin the
 * group call without an active ring (Robert, 2026-10-13: "a little banner
 * that asks them to accept or decline"). The server asks only the host and
 * closes the banner on every host device (vrs-server/ws/group-join-approval.js).
 */
import React from 'react';
import { joinRequestText } from '../groupJoinRequests';
import { useGroupJoinRequests } from '../useGroupJoinRequests';
const GroupJoinRequestBanner = () => {
    const { requests, respond } = useGroupJoinRequests();
    const request = requests[0];
    if (!request) {
        return null;
    }
    const text = joinRequestText(request);
    const more = requests.length - 1;
    return (React.createElement("div", { "aria-live": 'polite', className: 'group-join-banner', role: 'status' },
        React.createElement("span", { className: 'group-join-banner-label' },
            text,
            more > 0 ? ` · ${more} more` : ''),
        React.createElement("button", { "aria-label": `Accept: ${text}`, className: 'group-join-banner-btn accept', disabled: request.answering, onClick: () => respond(request, true), type: 'button' }, "Accept"),
        React.createElement("button", { "aria-label": `Decline: ${text}`, className: 'group-join-banner-btn decline', disabled: request.answering, onClick: () => respond(request, false), type: 'button' }, "Decline")));
};
export default GroupJoinRequestBanner;
